import * as actionTypes from './actionTypes';
import API from '../../axios/api';
import { toastr } from 'react-redux-toastr'

export const getTokenSignupSuccess = (userToken) => {
    return {
        type: actionTypes.GET_TOKEN_SIGNUP,
        userToken: userToken
      }
}

export const getTokenConfirmAddTenantOrUserSuccess = (userToken) => {
    return {
        type: actionTypes.GET_TOKEN_CONFIRM_ADD_TENANT_OR_USER,
        userToken: userToken
      }
}

export const requestTokensStart = () => {
    return {
      type: actionTypes.REQUEST_TOKENS_START
    };
  };

export const requestTokensFail = (error) => {
    return {
      type: actionTypes.REQUEST_TOKENS_FAIL,
      error: error
    };
  };


export const getTokenSignup = (tokenId) => {
    return dispatch => {
        return new Promise((resolve, reject) => {
            dispatch(requestTokensStart());
            API.get('/tokens/signup/' + tokenId)
            .then(res => {
                dispatch(getTokenSignupSuccess(res.data));
                resolve(res.data);
            })
            .catch(err => {
                dispatch(requestTokensFail(err));
                toastr.error('Erro', err.response)
                resolve('error');
            });
        })
    }
}

export const getTokenConfirmAddTenantOrUser = (tokenId) => {
    return dispatch => {
        return new Promise((resolve, reject) => {
            dispatch(requestTokensStart());
            API.get('/tokens/confirmaddtenantoruser/' + tokenId)
            .then(res => {
                dispatch(getTokenConfirmAddTenantOrUserSuccess(res.data));
                resolve(res.data);
            })
            .catch(err => {
                dispatch(requestTokensFail(err));
                toastr.error('Erro', err.response)
                resolve('error');
            });
        })
    }
}
